// Youtube Reducer

const youtubeReducerDefaultState = {
    youTubeVideosList: {}
};

export default (state = youtubeReducerDefaultState, action) => {

    switch (action.type) {

        case 'LIST_YOUTUBE_VIDEOS':
            return {
                ...state,
                youTubeVideosList: action.youTubeVideos
            };
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/reducers/youtube.js